import { ComponentsOverrides, Theme } from "@mui/material";

type MuiSelect = {
  styleOverrides: ComponentsOverrides<Theme>["MuiSelect"];
};

const muiInputLabel: MuiSelect = {
  styleOverrides: {
    select: ({ ownerState }) => ({
      ...(ownerState.variant === "filled" && {
        "&.MuiSelect-filled:focus": {
          backgroundColor: "transparent",
        },
      }),
    }),
  },
};

export default muiInputLabel;
